export const heatmapFetchDataKeyReset = (state, payload) => {
  return {
    ...state,
    isDataFetched: false,
    isDataFetchedManager: false
  }

}